import * as leaflet from './leaflet'
import * as leafletSleep from './leaflet-sleep'

export default {
  leafletSleep,
  leaflet,
}
